const agendaSelect = {
    init: () => {
        reservationList.bindCancelButtons();
    }
}